import { shuffle } from 'lodash';
import React, { useEffect, useRef, useState } from 'react'
import ItemBlock from './components/ItemBlock';
import './style.scss'
let isMouseDown, context, startX, startY, canvas;

function AnswersType7({answers, onChange, isAnswer, help}) {
  const ref = useRef(null);
  const [selected, setSelected] = useState(-1)
  const [items, setItems] = useState([])
  const [itemAnswers, setAnswers] = useState([])


  const drawLine = (e) =>  {
    if (selected > -1) {
      const position = canvas.getBoundingClientRect();
      const x = (e.pageX - position.left);
      const y = (e.pageY - position.top);
      context.clearRect(0,0,canvas.width,canvas.height);

      if(items[selected].endX && items[selected].endY){
        delete items[selected].endX;
        delete items[selected].endY;
        delete items[selected].answerId;
      }
      moveLine(items[selected].startX, items[selected].startY, x, y)
      reloadLines(items);
    }
  }

  function reloadLines(tmp) {
    tmp.forEach(item => {
      if(item.endX && item.endY){
        moveLine(item.startX, item.startY, item.endX, item.endY)
      }
    })
  }

  const endLine = (index, answerId) => {
    const endX = 400;
    const endY = index * 80 + 20 + 25;
    const tmp = [...items].map(_i => {
      if(_i.endX == endX && _i.endY == endY){
        delete _i.endX;
        delete _i.endY;
        delete _i.answerId;
      }
      return {..._i}
    })

    
    tmp[selected].endX = endX;
    tmp[selected].endY = endY;
    tmp[selected].answerId = answerId;
    if(!tmp.some(_i => !_i.endX)){
      onChange(tmp)
    }
    setItems(tmp)
    setSelected(-1);
    context.clearRect(0,0,canvas.width,canvas.height);
    reloadLines(tmp);
  }

  function moveLine(s_x, s_y, e_x, e_y) {
    context.beginPath();
    // context.setLineDash([8, 5]);
    context.moveTo(s_x, s_y);
    context.lineTo(e_x, e_y);
    context.stroke();
    context.closePath();
  };

  useEffect(() => {
    if(ref.current){
      canvas = ref.current;
      context = canvas.getContext("2d");
    }
    setItems(answers.map((_i, index) => ({
      ..._i,
      // startY: 0,
      startY: index * 80 + 20 + 25,
      startX: 20 + 200,
    })))
    
    setAnswers(shuffle(answers))
  }, [answers])


  const h = items.length * 80 + 20;
  return (
    <div className='AnswersType7'>
      {isAnswer && <div className='blockedAnswer' />}
      <div className='block'>
        <canvas 
            ref={ref} 
            width="630" 
            height={h}
            // onMouseDown={(e) => {
            //   isMouseDown = true;
            //   const position = canvas.getBoundingClientRect();
            //   startX = (e.pageX - position.left);
            //   startY = (e.pageY - position.top); 
            // }}
            onMouseMove={drawLine}
            // onMouseUp={endLine}
          />
          {items.map((_i, index) => <ItemBlock 
            selected={selected} 
            onSelected={() => {setSelected(index)}} 
            index={index} 
            item={_i} 
            row={1} 
            items={items} 
          />)}
          {itemAnswers.map((_i, index) => <ItemBlock 
            index={index} 
            item={_i} 
            row={2}
            isCorrect={items.some(_a => _a._id == _i._id && _i._id == _a.answerId)}
            isAnswer={isAnswer}
            help={help}
            items={items}
            onClick={(answerId) => {
              endLine(index, answerId)
            }} 
            onHover={() => {
              if(selected > -1){
                const x = 400;
                const y = index * 80 + 20 + 25;
                context.clearRect(0,0,canvas.width,canvas.height);
                moveLine(items[selected].startX, items[selected].startY, x, y)
                reloadLines(items);
              }
            }}/>)}
      </div>
    </div>
  )
}

export default AnswersType7


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswersType7/AnswersType7.jsx